import { Button } from "@/components/ui/button";
import { DialogClose } from "@/components/ui/dialog";

interface ISecondaryButton {
  onSecondaryButtonClick?: () => void;
  secondaryButtonText: string;
  disabled?: boolean;
}

export default function SecondaryButton(props: ISecondaryButton) {
  const { onSecondaryButtonClick, secondaryButtonText, disabled } = props;

  return onSecondaryButtonClick ? (
    <Button onClick={onSecondaryButtonClick} size="md" variant="outline" disabled={disabled}>
      {secondaryButtonText}
    </Button>
  ) : (
    <DialogClose asChild={true}>
      <Button size="md" variant="outline" disabled={disabled}>
        {secondaryButtonText}
      </Button>
    </DialogClose>
  );
}
